// Informations de l'entreprise — source unique de vérité pour le site.
// Reprises fidèlement du site actuel www.maisongilles.be.

export const SITE = {
  nom: 'Maison Gilles',
  baseline: 'Votre spécialiste en matériel de jardin à Jambes',
  depuis: 1925,
  adresse: 'Chaussée de Marche 182',
  cp: '5100',
  ville: 'Jambes',
  tva: 'BE0446.916.810',
  telephone: '081 30 11 94',
  telephoneLien: '+3281301194',
  email: 'info@maisongilles.be',
  facebook: 'https://www.facebook.com/MaisonGilles',
  instagram: 'https://www.instagram.com/maisongilles',
  googleMaps: 'https://www.google.com/maps?cid=7942683284689364412',
  googleAvis: 'https://g.page/r/CbylV4NdFDpuEBM/review',
  husqvarnaDealers: 'https://maison-gilles.husqvarnadealers.be',
  mapsQuery: 'Maison Gilles, Chaussée de Marche 182, 5100 Jambes',
  noteGoogle: '4,7',
}

// Bandeau d'annonce en haut de page (modifiable facilement).
// Mettre `actif: false` pour le masquer.
export const ANNONCE = {
  actif: true,
  texte:
    "Exceptionnellement et en raison des fortes chaleurs, le magasin fermera ses portes à 16h00 ces jeudi 25, vendredi 26 et samedi 27 juin. Merci pour votre compréhension. — FERMETURE ANNUELLE : du lundi 20 juillet au lundi 27 juillet 2026 inclus et du lundi 17 août au lundi 24 août 2026 inclus.",
}

export const HORAIRES = [
  { jour: 'Lundi', heures: 'Fermé', ferme: true },
  { jour: 'Mardi', heures: '9h00 – 18h00' },
  { jour: 'Mercredi', heures: '9h00 – 18h00' },
  { jour: 'Jeudi', heures: '9h00 – 18h00' },
  { jour: 'Vendredi', heures: '9h00 – 18h00' },
  { jour: 'Samedi', heures: '9h00 – 18h00' },
  { jour: 'Dimanche', heures: 'Fermé', ferme: true },
]

export type NavItem = {
  label: string
  to?: string
  children?: { label: string; to: string }[]
}

export const NAV: NavItem[] = [
  { label: 'Accueil', to: '/' },
  { label: 'Nos marques', to: '/#marques' },
  { label: 'Robots tondeuses', to: '/#robots' },
  { label: "Demande d'enlèvement", to: '/enlevement' },
  { label: 'Contact', to: '/#contact' },
]
